import { defineMessages } from 'react-intl';

export const freightBrowserMessages = defineMessages({
  title: {
    defaultMessage: 'Rate Browser',
    id: '2/7sBW',
    description: 'Title for the freight rate browser drawer',
  },
  browseRates: {
    defaultMessage: 'Browse Rates',
    id: 'F2AmSu',
    description: 'Button label to fetch freight rates',
  },
  saveQuote: {
    defaultMessage: 'Save Quote',
    id: 'Jlh4aK',
    description: 'Button label to save the current quote',
  },
  configureShipment: {
    defaultMessage: 'Configure Shipment',
    id: 'lZ+eOq',
    description: 'Button label to configure shipment from selected quote',
  },
});
